import { FC } from 'react';

import { Panel } from '../PanelLayout';
import { PanelTemplateProps } from '../types';

const HeaderPanel: FC<PanelTemplateProps> = ({
  children,
  name,
  ...otherProps
}) => {
  return (
    <Panel name={name || 'header'} {...otherProps}>
      {children}
    </Panel>
  );
};

export default HeaderPanel;
